<div class="max-h-fit pl-4 sm:pl-6 md:pl-8 lg:pl-10 pr-2 sm:pr-4">
    <!-- Page Title -->
  <div class="flex items-center justify-between pt-5 pb-2">
    <h1 class="text-dark-purple text-3xl font-bold">{{ pageTitle }}</h1>
    <prism-btn 
      btnClass="bg-white text-dark-purple font-bold border-2 p-0 m-0 rounded-xl border-dark-purple"
      (click)="downloadReport()"
      [disabled]="!data.length"
    >
      <i class="uil uil-import text-dark-purple font-bold pr-1"></i>
      Download Report
    </prism-btn>
  </div>

  <!-- Filter Controls -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 pb-4">
    <div class="w-full mt-6">
      <prism-input 
        inputType="text" 
        [control]="search"
        [required]="false"
        placeHolder="Search for name, course, etc..."
        [hasSearch]="true"
        (search)="searchReport()">
      </prism-input>
    </div>

    <div class="w-full">
      <prism-select-school-year
        [required]="false"
        [readOnly]="false"
        label="Academic Year"
        placeholder="Show All"
        [control]="schoolYear">
      </prism-select-school-year>
    </div>

    <div class="w-full">
      <prism-select-organization
        [control]="organization"
        [label]="'District'"
        [required]="false"
        [readOnly]="false"
        (organization)="onOrganizationSelected($event)">
      </prism-select-organization>
    </div>

    <div class="w-full">
      <prism-select
        [selectOptions]="completionStatusOptions"
        label="Completion Status"
        placeHolder="Show All"
        [control]="completionStatus"
        [required]="false"
        [readOnly]="false"
        [allowDeselect]="true"
        labelClass="">
      </prism-select>
    </div>
  </div>

  <prism-table 
    [columns]="columns" 
    [colHeaders]="colHeaders" 
    [tableData]="data" 
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [totalData]="totalData"
    (pageIndexChange)="handlePageIndexChange($event)"
    (pageSizeChange)="handlePageSizeChange($event)"
    (columnDirectionChange)="handleColumnDirectionChange($event)">
    <h2 table-title class="text-dark-purple text-xl font-bold">Results</h2>
  </prism-table>
</div>